import {IBaseLookup} from "./Ibase.lookup";

export namespace WebModelUpdates {

	export const lookupName: string = "WebModelUpdates";

	export interface WebModelUpdates {
		webModelUpdateKey:number;
		name:string;
		conditions:string;
		actions:string;
		elseActions:string;
		requireUi:string;
		override:string;
		sequenceId:number;
		active:string;
		lastUpdated:Date;
	}

	export interface WebModelUpdatesDS extends IBaseLookup {
		webModelUpdates: WebModelUpdates[];
	}
}

